const requiredFields = ['roleName', 'roleDescription', 'permissions'];

const rolesDialogConfig = {
  requiredFields
};

module.exports = rolesDialogConfig;
